import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dum-historia',
  templateUrl: './historia.component.html',
  styleUrls: ['./historia.component.scss']
})
export class HistoriaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
